import React from 'react';

import Icon from './Icon';

// Utils
import { COMPARISON_ITEM_TYPES } from '../../../utils/constants';
import Dictionary from '@/types/dictionary';

import { formatMessage } from '@/utils/i18n';

export type Props = {
  color?: string;
  type: string;
  className?: string;
  size?: number;
  boxPad?: number;
  margin?: string;
};

const HOLDING_CONFIG: Dictionary<{ icon: string; label: string }> = {
  [COMPARISON_ITEM_TYPES.ALT]: {
    icon: 'ds-product-alternative',
    label: 'Common.Alt',
  },
  [COMPARISON_ITEM_TYPES.BENCHMARK]: {
    icon: 'score',
    label: 'Common.Benchmark',
  },
  [COMPARISON_ITEM_TYPES.FUND]: {
    icon: 'icon-circle',
    label: 'Common.Fund',
  },
  [COMPARISON_ITEM_TYPES.GROUP]: {
    icon: 'folder',
    label: 'Common.Group',
  },
  [COMPARISON_ITEM_TYPES.PORTFOLIO]: {
    icon: 'icon-portfolio',
    label: 'Common.Portfolio',
  },
  [COMPARISON_ITEM_TYPES.STOCK]: {
    icon: 'icon-diamond',
    label: 'Common.Stock',
  },
};

export const getIconName = (type: string): string => HOLDING_CONFIG[type]?.icon || '';
export const getIconLabel = (type: string): string => (HOLDING_CONFIG[type] ? formatMessage(HOLDING_CONFIG[type].label) : '');

const HoldingIcon = ({ color, type, size, boxPad, margin }: Props) => (
  <Icon role="img" title={getIconLabel(type)} color={color} type={getIconName(type)} size={size} boxPad={boxPad} margin={margin} className="pdf-ignore" />
);

export default HoldingIcon;
